import * as $ from "jquery";
import AbstractElement from "./AbstractElement";
import ScrollMagic from "scrollmagic";
import YoutubePlayer from "../components/YoutubePlayer";

class VideoSection extends AbstractElement {

  constructor(htmlElement, smController) {
    super(htmlElement);
    this.smController = smController;
    this.content = this.htmlElement.querySelector('.app_section_content');
    this.triggerScenes = [];
    this.triggerNodes = this.htmlElement.querySelectorAll('.trigger');

    this.youtubePlayer = null;
    this.createYoutubePlayer = this.createYoutubePlayer.bind(this);
    this.createYoutubePlayer();
  }


  resizeHandler() {

    if (this.contentScene) {
      this.contentScene.duration(
        this.htmlElement.clientHeight - window.innerHeight
      );
    }
    if (this.triggerScenes && this.triggerScenes.length) {
      const triggerList = Array.apply(null, this.triggerNodes);
      triggerList.map((item, index) => {
        const scene = this.triggerScenes[index];
        scene.duration(item.clientHeight);
      });
    }
    super.resizeHandler();
  }

      createYoutubePlayer() {
          this.youtubePlayer = new YoutubePlayer();
          this.youtubePlayer.emitter.on('ON_YOUTUBE_API_READY', () => {
              this.youtubePlayer.videoId = '3V9PtFfWoWU';
              this.youtubePlayer.loop = true;
              this.youtubePlayer.mute = false;
              this.youtubePlayer.createPlayer('youtubePlayer');
          });
          this.youtubePlayer.emitter.on('YOUTUBE_PLAYER_READY', () => {
              // this.youtubePlayer.playVideo();
          });
          this.youtubePlayer.loadYoutubeAPI();
      }


          createScrollEffect() {
              // content
              this.contentScene = new ScrollMagic.Scene({
                  triggerElement: this.content,
                  triggerHook: 0,
                  duration: this.htmlElement.clientHeight - window.innerHeight
              })
                  .setPin(this.content)
                  .addTo(this.smController);

              // triggers
              const triggerList = Array.apply(null, this.triggerNodes);
              triggerList.map((item, index) => {
                  const triggerScene = new ScrollMagic.Scene({
                      triggerElement: item,
                      triggerHook: 0.5,
                      duration: item.clientHeight
                  })
                      .on('enter', (event) => this.animateContent(index))
                      .on('leave', (event) => this.resetContent(index))
                      .addTo(this.smController);
                  this.triggerScenes.push(triggerScene);
              });

              const videoElement = this.htmlElement.querySelector('.video__container');
              const videoTrigger = new ScrollMagic.Scene({
                  triggerElement: videoElement,
                  triggerHook: 0.5,
                  duration: videoElement.clientHeight
              })
                  .on('enter', (event) => {
                      if (this.youtubePlayer && this.youtubePlayer.player && window.innerWidth>=1024) {
                          this.youtubePlayer.playVideo();
                      }
                  })
                  .on('leave', (event) => {
                      if (this.youtubePlayer && this.youtubePlayer.player) {
                          this.youtubePlayer.pauseVideo();
                      }
                  })
                  .addTo(this.smController);
          }

          animateContent(triggerId) {

          }

          resetContent(triggerId) {

          }
      }

      export default VideoSection;
